export const priorityOptions = [
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
];

export const privacyOptions = [
    { value: 'public', label: 'Public' },
    { value: 'private', label: 'Private' },
    { value: 'team', label: 'Team Only' }
];

export const assigneeOptions = [
    { value: 'john-doe', label: 'John Doe' },
    { value: 'jane-smith', label: 'Jane Smith' },
    { value: 'mike-johnson', label: 'Mike Johnson' },
    { value: 'sarah-wilson', label: 'Sarah Wilson' },
    { value: 'david-brown', label: 'David Brown' }
];

export const projectOptions = [
    { value: 'project1', label: 'Project Management System' },
    { value: 'project2', label: 'E-commerce Website' },
    { value: 'project3', label: 'Mobile App Development' },
    { value: 'project4', label: 'CRM System' },
    { value: 'project5', label: 'Marketing Website' }
];

export const taskListOptions = [
    { value: 'list1', label: 'Frontend Tasks' },
    { value: 'list2', label: 'Backend Tasks' },
    { value: 'list3', label: 'Design Tasks' },
    { value: 'list4', label: 'Testing Tasks' },
    { value: 'list5', label: 'Documentation' }
];

export const stageOptions = [
    { value: 'completed', label: 'Completed' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'planning', label: 'Planning' },
    { value: 'pending', label: 'Pending' },
    { value: 'backlog', label: 'Backlog' },
    { value: 'hold', label: 'Hold' }
];